import { Token } from '@usedapp/core'
import { getTokenImage } from 'utils'
import { Img } from '../Image'

export function AssetIcon({ token, size = 22 }: { token: Token; size?: number }) {
  const image = getTokenImage(token.ticker.toUpperCase())

  return <Img image={image} size={size} />
}
